import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { boiDepartmentId } from "libs/configs/constant";
import LoadingAdapter from "libs/utils/LoadingAdapter";
import { selectIsAdmin, selectIsBOI } from "redux/modules/authSlice";
import AllDocumentsService from "services/AllDocumentsService";

let initialState = {
  list: [], detail: {}, consults: [], logs: [],
  translateData: null
};

export const getAllDocumentsList = createAsyncThunk(
  "allDocuments/getallDocuments",
  async (body) => {
    const response = await AllDocumentsService.getAllDocuments(body);
    return response?.results;
  }
);



export const approveDoc = createAsyncThunk(
  "allDocuments/approveDoc",
  async (body) => {
    const response = await AllDocumentsService.approveDoc(body);
    if (response.status) {
      const res = await AllDocumentsService.getAllDocuments(body);
      if (res.status && res.results.length > 0) {
        const detail = res.results[0];
        return detail;
      }
    }
  }
);


export const forceApprove = createAsyncThunk(
  "allDocuments/forceApprove",
  async (body) => {
    const response = await AllDocumentsService.forceApprove(body);
    if (response.status) {
      const res = await AllDocumentsService.getAllDocuments(body);
      if (res.status && res.results.length > 0) {
        const detail = res.results[0];
        return detail;
      }
    }
  }
);



export const otherApproveDoc = createAsyncThunk(
  "allDocuments/otherApproveDoc",
  async (body) => {
    console.log(body);
    const response = await AllDocumentsService.otherApproveDoc(body);
    if (response.status) {
      const res = await AllDocumentsService.getAllDocuments(body);
      if (res.status && res.results.length > 0) {
        const detail = res.results[0];
        return detail;
      }
    }
  }
);



export const undoDoc = createAsyncThunk(
  "allDocuments/undoDoc",
  async (body) => {
    const response = await AllDocumentsService.undo(body);
    if (response.status) {
      const res = await AllDocumentsService.getAllDocuments(body);
      if (res.status && res.results.length > 0) {
        const detail = res.results[0];
        return detail;
      }
    }
  }
);


export const otherUndo = createAsyncThunk(
  "allDocuments/otherUndo",
  async (body) => {
    const response = await AllDocumentsService.otherUndo(body);
    if (response.status) {
      const res = await AllDocumentsService.getAllDocuments(body);
      if (res.status && res.results.length > 0) {
        const detail = res.results[0];
        return detail;
      }
    }
  }
);


export const staffBOIApprove = createAsyncThunk(
  "allDocuments/staffBOIApprove",
  async (body) => {
    const response = await AllDocumentsService.staffBOIApprove(body);
    if (response.status) {
      const res = await AllDocumentsService.getAllDocuments(body);
      if (res.status && res.results.length > 0) {
        const detail = res.results[0];
        return detail;
      }
    }
  }
);




export const rejectDoc = createAsyncThunk(
  "allDocuments/rejectDoc",
  async (body) => {
    const response = await AllDocumentsService.rejectDoc(body);
    if (response.status) {
      const res = await AllDocumentsService.getAllDocuments(body);
      if (res.status && res.results.length > 0) {
        const detail = res.results[0];
        return detail;
      }
    }
  }
);


export const requestDocuments = createAsyncThunk(
  "allDocuments/requestDocuments",
  async (body) => {
    const response = await AllDocumentsService.requestDocuments(body);
    if (response.status) {
      const res = await AllDocumentsService.getAllDocuments({ draftId: body.draftId });
      if (res.status && res.results.length > 0) {
        const detail = res.results[0];
        return detail;
      }
    }
  }
);


export const reassignDoc = createAsyncThunk(
  "allDocuments/reassignDoc",
  async (body) => {
    const response = await AllDocumentsService.reassignDoc(body);
    if (response.status) {
      const res = await AllDocumentsService.getAllDocuments({ draftId: body.draftId });
      if (res.status && res.results.length > 0) {
        const detail = res.results[0];
        return detail;
      }
    }
  }
);


export const consultDoc = createAsyncThunk(
  "allDocuments/consultDoc",
  async (body) => {
    const response = await AllDocumentsService.consultDoc(body);
    if (response.status) {
      const res = await AllDocumentsService.getAllDocuments({ draftId: body.draftId });
      if (res.status && res.results.length > 0) {
        const detail = res.results[0];
        return detail;
      }
    }
  }
);


export const superaccessList = createAsyncThunk(
  "allDocuments/superaccessList",
  async (body) => {
    const response = await AllDocumentsService.superaccessList(body);
    if (response.status) {
      return response.results;
    }
  }
);


export const superaccessremove = createAsyncThunk(
  "allDocuments/superaccessremove",
  async (body) => {
    const response = await AllDocumentsService.superaccessremove(body);
    if (response.status) {
      return response.status;
    }
  }
);

export const docLogs = createAsyncThunk(
  "allDocuments/docLogs",
  async (body) => {
    const response = await AllDocumentsService.docLogs(body);
    if (response.status) {
      return response.results;
    }
  }
);


export const translateDoc = createAsyncThunk(
  "allDocuments/translateDoc",
  async (body) => {
    const response = await AllDocumentsService.translateDoc(body);
    if (response.status) {
      return response.results;
    }
  }
);

export const boiapproveex = createAsyncThunk(
  "allDocuments/boiapproveex",
  async (body) => {
    console.log(body);
    const response = await AllDocumentsService.boiapproveex(body);
    if (response.status) {
      const res = await AllDocumentsService.getAllDocuments(body);
      if (res.status && res.results.length > 0) {
        const detail = res.results[0];
        return detail;
      }
    }
  }
);



const allDocumentsSlice = createSlice({
  name: "allDocuments",
  initialState: LoadingAdapter.getInitialState(initialState),
  reducers: {
    clearAll: LoadingAdapter.getInitialState(initialState),
    clearAsyncState: LoadingAdapter.clearAsyncState,
    setDocDetail(state, action) {
      state.detail = action.payload;
    },
    clearConsults(state, action) {
      state.consults = [];
    },
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(getAllDocumentsList, builder, ["list"]);
    LoadingAdapter.applyAsyncBuilder(approveDoc, builder, ["detail"]);
    LoadingAdapter.applyAsyncBuilder(undoDoc, builder, ["detail"]);
    LoadingAdapter.applyAsyncBuilder(otherUndo, builder, ["detail"]);
    LoadingAdapter.applyAsyncBuilder(rejectDoc, builder, ["detail"]);
    LoadingAdapter.applyAsyncBuilder(otherApproveDoc, builder, ["detail"]);
    LoadingAdapter.applyAsyncBuilder(reassignDoc, builder, ["detail"]);
    LoadingAdapter.applyAsyncBuilder(consultDoc, builder, ["detail"]);
    LoadingAdapter.applyAsyncBuilder(superaccessList, builder, ["consults"]);
    LoadingAdapter.applyAsyncBuilder(docLogs, builder, ["logs"]);
    LoadingAdapter.applyAsyncBuilder(forceApprove, builder, ["detail"]);
    LoadingAdapter.applyAsyncBuilder(staffBOIApprove, builder, ["detail"]);
    LoadingAdapter.applyAsyncBuilder(requestDocuments, builder, ["detail"]);
    LoadingAdapter.applyAsyncBuilder(boiapproveex, builder, ["detail"]);
    LoadingAdapter.applyAsyncBuilder(translateDoc, builder, ["translateData"]);
  },
});

export const { setDocDetail, clearConsults } = allDocumentsSlice.actions;

export default allDocumentsSlice.reducer;

export const selectApproveDocStatus = (state) => {
  const approveStastus = ["RA", "SM", "SR", "V"];
  const { departmentId } = state.user.profile;
  const { detail } = state.allDocuments;

  if (detail && detail.configApprveSmartFrom && departmentId) {
    const doc = detail.configApprveSmartFrom.find(
      (x) => x.departmentId === departmentId
    );

    return doc && approveStastus.indexOf(doc.statusProcessId) ? true : false;
  }
  return false;
};

export const selectBOIApproveDocStatus = (state) => {
  const approveStastus = ["SM", "SR", "V"];
  const departmentId = boiDepartmentId;
  const { detail } = state.allDocuments;

  if (detail && detail.configApprveSmartFrom && departmentId) {
    const doc = detail.configApprveSmartFrom.find(
      (x) => x.departmentId === departmentId
    );

    return doc && approveStastus.indexOf(doc.statusProcessId) > -1
      ? true
      : false;
  }
  return false;
};

export const selectHasOneApprove = (state) => {
  const approveOnce = ["A", "S"];
  const departmentId = boiDepartmentId;
  const { detail } = state.allDocuments;

  if (detail && detail.configApprveSmartFrom && departmentId) {
    const doc = detail.configApprveSmartFrom.find(
      (x) => x.departmentId === departmentId
    );

    return doc && approveOnce.indexOf(doc.statusProcessId) > -1 ? true : false;
  }
  return false;
};

export const SelectBOICanApprove = (state) => {
  const isAdmin = selectIsAdmin(state);
  const isBOI = selectIsBOI(state);

  const approveStastus = ["SM", "SR", "V"];
  const departmentId = boiDepartmentId;
  const { detail } = state.allDocuments;

  if (detail && detail.configApprveSmartFrom) {
    const doc = detail.configApprveSmartFrom.find(
      (x) => x.departmentId === departmentId
    );
    const canApprove =
      doc && approveStastus.indexOf(doc.statusProcessId) > -1 ? true : false;

    return isAdmin && isBOI && canApprove;
  }
  return false;
};

export const SelectOtherCanApprove = (state) => {
  const isAdmin = selectIsAdmin(state);
  const isBOI = selectIsBOI(state);

  const approveStastus = ["SR", "V", "P"];
  const { departmentId } = state.user.profile;
  const { detail } = state.allDocuments;

  if (detail && detail.configApprveSmartFrom) {
    const doc = detail.configApprveSmartFrom.find(
      (x) => x.departmentId === departmentId
    );
    const canApprove =
      doc && approveStastus.indexOf(doc.statusProcessId) > -1 ? true : false;
    return isAdmin && !isBOI && canApprove;
  }
  return false;
};

export const SelectBOICanCancel = (state) => {
  const isAdmin = selectIsAdmin(state);
  const isBOI = selectIsBOI(state);

  const approveStastus = ["S"];
  const departmentId = boiDepartmentId;
  const { detail } = state.allDocuments;

  if (detail && detail.configApprveSmartFrom) {
    const doc = detail.configApprveSmartFrom.find(
      (x) => x.departmentId === departmentId
    );
    const canApprove =
      doc && approveStastus.indexOf(doc.statusProcessId) > -1 ? true : false;
    const otherApproveOnce = detail.configApprveSmartFrom
      .filter((x) => x.departmentId !== departmentId)
      .find((x) => x.statusProcessId === "A");
    return isAdmin && isBOI && canApprove && !otherApproveOnce;
  }
  return false;
};

export const SelectOtherCanCancel = (state) => {
  const isAdmin = selectIsAdmin(state);
  const isBOI = selectIsBOI(state);

  const approveStastus = ["A"];
  const { departmentId } = state.user.profile;
  const { detail } = state.allDocuments;

  if (detail && detail.configApprveSmartFrom) {
    const doc = detail.configApprveSmartFrom.find(
      (x) => x.departmentId === departmentId
    );
    const canApprove =
      doc && approveStastus.indexOf(doc.statusProcessId) > -1 ? true : false;

    return isAdmin && !isBOI && canApprove;
  }
  return false;
};

export const SelectCanReject = (state) => {
  const isAdmin = selectIsAdmin(state);
  return isAdmin;
};
